import Image from '@/Ui/components/image/image';
import { FC } from 'react';

interface IIcon {
    src: string,
    onClick?: () => void,
    width?: number | string,
    height?: number | string,
    className?: string
}

export const Icon: FC<IIcon> = ({ height = 30, src, width = 30, onClick, className }) => {
    return (
        <Image
            className={className}
            src={src}
            width={width}
            height={height}
            onClick={onClick}
        />
    )
}